import React from 'react';
import { IScheduleDemoFormValues } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm/interfaces';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import { Tenant as TenantType } from '@framework/tenant/vo/types/Tenant';
import { ILogoProps } from '@dealroadshow/uikit-logo/types';

interface IProps {
  isScheduleDemoModalVisible: boolean,
  toggleScheduleDemoModal: () => void,
  scheduleDemoModal: React.ElementType,
  tenant: TenantType,
  logoComponent: React.ComponentType<ILogoProps>,
  buttonComponent?: React.ElementType,
  title?: string,
  className?: string,
  variantType?: keyof typeof ButtonVariantType,
  defaultPhoneCountry?: string,
  getInitialFormValues?: () => IScheduleDemoFormValues | null,
  openModalWithUrl?: () => void,
  dataTest?: string,
}

const BookDemoButton = ({
  isScheduleDemoModalVisible,
  toggleScheduleDemoModal,
  scheduleDemoModal: ScheduleDemoModal,
  tenant,
  logoComponent,
  buttonComponent: ButtonComponent,
  title = 'Book Demo',
  className,
  variantType = ButtonVariantType.action as keyof typeof ButtonVariantType,
  defaultPhoneCountry,
  getInitialFormValues,
  openModalWithUrl,
  dataTest = 'bookDemoButton',
}: IProps) => {
  const handleClick = () => {
    if (openModalWithUrl) {
      openModalWithUrl();
    } else {
      toggleScheduleDemoModal();
    }
  };

  const button = ButtonComponent ? (
    <ButtonComponent
      className={ className }
      onClick={ handleClick }
      dataTest={ dataTest }
    >
      { title }
    </ButtonComponent>
  ) : (
    <Button
      variant={ variantType }
      className={ className }
      onClick={ handleClick }
      type="button"
      title={ title }
      dataTest={ dataTest }
    />
  );

  return (
    <>
      { button }
      { isScheduleDemoModalVisible && (
        <ScheduleDemoModal
          tenant={ tenant }
          defaultPhoneCountry={ defaultPhoneCountry }
          getInitialFormValues={ getInitialFormValues }
          logoComponent={ logoComponent }
          closeModal={ toggleScheduleDemoModal }
        />
      ) }
    </>
  );
};

export default BookDemoButton;
